import React from 'react';
import PropTypes from 'prop-types';
import { Box, Popover } from '@mui/material';
import Calendar from '../../../Components/Common/Calendar';

/**
 * Date picker popover component for selecting reservation date
 * @param {Object} props - Component props
 * @param {boolean} props.open - Popover open state
 * @param {HTMLElement} props.anchorEl - Anchor element for popover
 * @param {Function} props.onClose - Close handler
 * @param {Function} props.onDateSelect - Date selection handler
 */
const DatePickerPopover = ({ open, anchorEl, onClose, onDateSelect }) => {
  const popoverId = open ? 'date-picker-popover' : undefined;

  const handleDateSelect = (selectedDate) => {
    onDateSelect(selectedDate);
    onClose();
  };

  return (
    <Popover
      id={popoverId}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Box>
        <Calendar
          future={false}
          past={true}
          onChildValue={handleDateSelect}
        />
      </Box>
    </Popover>
  );
};

DatePickerPopover.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.instanceOf(Element),
  onClose: PropTypes.func.isRequired,
  onDateSelect: PropTypes.func.isRequired,
};

export default DatePickerPopover;
